export const routes = {
    login: "/login",
    register: "/register",
    forgotPassword: "/forgot-password",
    profile: "/profile",
    calculator: "/calculator",
    pricing: "/pricing",

    // ADMIN ROUTES
    admin: {
        index: "/admin",
        login: "/admin/login",
        transactions: "/admin/transactions",
        users: "/admin/users",
        discounts: "/admin/discounts",
    },
};
